<template>
  <div class="loginAction">
    <div class="loginAction__img">
        <Svg icon="lock" class="loginAction__img--svg"></Svg>
    </div>
    <h3>
        <slot></slot>
    </h3>
    <div class="loginAction__actions">
        <button class="btn btn--blue loginAction__actions--item" @click="$store.commit('showSignupPopup')">{{t('signup.title')}}</button>
        <button class="btn btn--blue-i loginAction__actions--item"  @click="$store.commit('showLoginPopup')">{{t('login.title')}}</button>
    </div>
    
    
</div>
</template>

<script>
import Svg from '../utils/Svg';
import { useI18n } from 'vue-i18n';

import en from "@/locales/en/authentication.json";
import fr from "@/locales/fr/authentication.json";

export default {
    components:{
        Svg
    },
    setup(){
        const {t}  = useI18n({
			messages:{
              en: en,
              fr: fr
            }
		});
        return {t}
    }
}
</script>

<style lang='scss' scoped>
@import '../../style/main';
.loginAction {
    border: 2px solid currentColor;
    border-radius: 3px;
    width: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;

    margin-bottom: 3rem;
    padding: 2rem;

    box-shadow: $shadow;

    &__img {
        margin-bottom: 2rem;
        &--svg {
        @include svg(6rem);
        }
    }

    & h3 {
        font-size: 1.6rem;
        font-weight: 400;
        letter-spacing: 0.1rem;
        margin-bottom: 2rem;
    }

    &__actions {
        display: flex;
        &--item{
            &:not(:last-child){
                margin-right: 1.5rem;
            }

        }
    }
}


</style>